module.exports = __webpack_public_path__ + "img/client_logo.8e5e26dc.svg";